/**
 * Descriptions for ViewContextHistoryStateService (Contact Us / support audit trail).
 * NOT used by RouteStore — RouteStore persists navigation state via route-view-state.helper.ts.
 */

export {
  describeApiRequestFailed,
  describeApiRequestStarted,
  describeApiRequestSucceeded,
  describeExportJobCreated,
  describeExternalLinkOpened,
  describeFilterApplied,
  describeFilterChange,
  describeFilterCleared,
  describeFormSubmitted,
  describeListLoaded,
  describeLoadedAfterFilter,
  describeModalCancelled,
  describeModalConfirmed,
  describeModalOpened,
  describeNavigatedToDetail,
  describePageChanged,
  describeReportDownloadFailed,
  describeReportDownloadStarted,
  describeRouteEntered,
  describeSearchPerformed,
  describeStartedCreateCase,
  describeUiStateChanged,
  describeViewReady,
  describeViewRefreshed,
  describeWebsocketJobUpdate,
  extractSupportErrorMessage,
  formatSupportContext,
  resolveSupportContextError,
} from "./support-event-descriptions.helper";

export {
  catchApiError,
  recordApiRequestFailed,
  recordApiRequestStarted,
  recordApiRequestSucceeded,
  createSupportHistoryContext,
  type CatchApiErrorOptions,
  type SupportHistoryRecordOptions,
  type SupportHistoryRecorder,
} from "./support-api-history.helper";
